import { CloseIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  description?: string;
  firstAction?: VoidFunction;
  firstActionTitle?: string;
  secondAction?: VoidFunction;
  secondActionTitle?: string;
  title: string;
};

export function Failure({
  description,
  firstAction,
  firstActionTitle,
  secondAction,
  secondActionTitle,
  title,
}: Props) {
  return (
    <div className="flex w-96 flex-col items-center rounded-companyBorderRadius border-2 border-border-primary bg-dark-gray p-8 text-center">
      <div className="h-[130px] w-[130px] rounded-full bg-neutral-600/[.15] p-[23px]">
        <div className="flex h-full w-full items-center justify-center rounded-full bg-background/primary">
          <CloseIcon className="w-2/3 h-2/3" />
        </div>
      </div>
      <div className="mt-8 text-2xl font-bold">{title}</div>
      {isTruthy(description) ? (
        <div className="mt-2 text-sm font-normal text-neutral-500">
          {description}
        </div>
      ) : null}
      <div className="mt-9 w-full">
        {firstAction ? (
          <ThemedButton
            dataTestId={`${firstActionTitle}-button`}
            fullWidth
            onClick={firstAction}
            variant="primary"
          >
            {firstActionTitle}
          </ThemedButton>
        ) : null}
        {secondAction ? (
          <div className="mt-2">
            <ThemedButton
              dataTestId="try-again-button"
              fullWidth
              onClick={secondAction}
              variant="secondary"
            >
              {secondActionTitle ?? m.btn_tryAgain()}
            </ThemedButton>
          </div>
        ) : null}
      </div>
    </div>
  );
}
